import { render, staticRenderFns } from "./ApplyTransformerModal.vue?vue&type=template&id=3b0ba474&"
import script from "./ApplyTransformerModal.vue?vue&type=script&lang=js&"
export * from "./ApplyTransformerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports